// extracted by mini-css-extract-plugin
export default {"pages":"AdminPagesEdit_pages__aUwyz","polygon_admin":"AdminPagesEdit_polygon_admin__8c8rU"};